import React from 'react';

const AuthFormContainer = ({
  title,
  children,
}: {
  title: string;
  children?: React.ReactNode;
}) => {
  return (
    <div className="flex w-full flex-col items-center gap-8 rounded-2xl border border-[#F0F0F5] bg-basic-white px-8 py-10 max-md:px-6 max-md:py-8 max-sm:px-5 max-sm:py-6">
      <h1 className="w-full gap-4 text-center text-[32px] font-bold leading-[38.4px] tracking-[0.64px] text-[#2E2E38] max-md:text-[28px] max-sm:text-2xl">
        {title}
      </h1>
      <div className="flex w-full flex-col items-start gap-3">{children}</div>
    </div>
  );
};

export default AuthFormContainer;
